import { DEFAULT_PREFECTURE_ID, DEFAULT_CITY_ID } from './CommonType';
import { getMainteDefault } from '../../utils/dateUtil';

// 一括入力
export type BulkInputInfo = {
    startYear?: string;
    startMonth?: string;
    endYear?: string;
    endMonth?: string;
    maintenanceLevelCode?: string;
    prefectureId?: string;
    cityId?: string;
};

// 見積条件 行毎
export type InputInfo = {
    modelid?: string; // 機種id
    makerName?: string; // メーカー名
    modelName?: string; // 機種名
    modelType?: string; // 型番
    freeWord?: string; // 検索キーワード
    number?: string; // 台数
    startYear?: string;
    startMonth?: string;
    endYear?: string;
    endMonth?: string;
    maintenanceLevelCode?: string;
    prefectureId?: string;
    cityId?: string;
};

// お見積条件入力内容全体(画面)
export type EstInput = {
    myListName?: string;
    bulkInput: BulkInputInfo;
    estimateInfo: Array<InputInfo>;
};

// 項目名
export const MYLIST_NAME = 'マイリスト名';

// セレクトリスト-年
export type YearSelect = {
    value: string;
    caption: string;
    firstFlg: boolean;
};

// セレクトリスト-月
export type MonthSelect = {
    value: string;
    caption: string;
    thisYear: number;
    thisMonth: number;
};

// 機器台数表示用
export const MODEL_COUNT = [
    { value: 1, caption: '1台' },
    { value: 2, caption: '2台' },
    { value: 3, caption: '3台' },
    { value: 4, caption: '4台' },
    { value: 5, caption: '5台' },
    { value: 6, caption: '6台' },
    { value: 7, caption: '7台' },
    { value: 8, caption: '8台' },
    { value: 9, caption: '9台' },
    { value: 10, caption: '10台' },
];

// 保守期間年月初期値
const [startDate, endDate] = getMainteDefault();

// お見積条件入力内容全体 初期値
export const EST_INPUT_INIT: EstInput = {
    myListName: '',
    bulkInput: {
        startYear: startDate.getFullYear().toString(),
        startMonth: (startDate.getMonth() + 1).toString(),
        endYear: endDate.getFullYear().toString(),
        endMonth: (endDate.getMonth() + 1).toString(),
        maintenanceLevelCode: '3',
        prefectureId: DEFAULT_PREFECTURE_ID.toString(),
        cityId: DEFAULT_CITY_ID.toString(),
    },
    estimateInfo: [],
};

export const ADD_EST_ROW_TEMPLATE: InputInfo = {
    modelid: '',
    modelName: '',
    modelType: '',
    freeWord: '',
    number: '1',
    startYear: startDate.getFullYear().toString(),
    startMonth: (startDate.getMonth() + 1).toString(),
    endYear: endDate.getFullYear().toString(),
    endMonth: (endDate.getMonth() + 1).toString(),
    maintenanceLevelCode: '3',
    prefectureId: DEFAULT_PREFECTURE_ID.toString(),
    cityId: DEFAULT_CITY_ID.toString(),
};

// マイリスト名入力欄最大長
export const MYLIST_NAME_MAX_LENGTH = 512;
